/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const CreateMonitoringIntegrationHeaders = zod.object({
  'x-csrf-token': zod.string(),
  'Idempotency-Key': zod.string(),
});

export type CreateMonitoringIntegrationHeaders = zod.input<
  typeof CreateMonitoringIntegrationHeaders
>;
export type CreateMonitoringIntegrationHeadersOutput = zod.output<
  typeof CreateMonitoringIntegrationHeaders
>;
